<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-12">
          <div class="h2">User Accounts</div>
          <!--<div class="row">-->
            <!--<div class="col-md-3">-->
              <!--<fg-select-->
                <!--label="Subscription Type"-->
                <!--v-model="subscriptionFilter"-->
                <!--:list="status"-->
                <!--selectedKey="id"-->
              <!--&gt;-->
              <!--</fg-select>-->
            <!--</div>-->
            <!--<div class="col-md-3" v-if="corps">-->
              <!--<fg-select-->
                <!--label="Corporation"-->
                <!--v-model="corporationFilter"-->
                <!--:list="corps"-->
                <!--selectedKey="name"-->
              <!--&gt;-->
              <!--</fg-select>-->
            <!--</div>-->
            <!--<div class="col-md-3">-->
              <!--<fg-select-->
                <!--label="User Type"-->
                <!--v-model="userFilter"-->
                <!--:list="userStatus"-->
                <!--selectedKey="name"-->
              <!--&gt;-->
              <!--</fg-select>-->
            <!--</div>-->
            <!--<div class="col-md-3" v-if="packages">-->
              <!--<fg-select-->
                <!--label="User Package"-->
                <!--v-model="packageFilter"-->
                <!--:list="packages"-->
                <!--selectedKey="packageId"-->
              <!--&gt;-->
              <!--</fg-select>-->
            <!--</div>-->
            <!--<div class="col-md-6 text-center">-->
              <!--<button type="button" @click="filterData()" class="btn btn-primary btn-fill btn-block">-->
                <!--<i class="fa fa-search-plus" aria-hidden="true"></i>Filter-->
              <!--</button>-->
              <!--<br>-->
            <!--</div>-->
            <!--<div class="col-md-6 text-center">-->
              <!--<button type="button" @click="resetFilters()" class="btn btn-primary btn-fill btn-block">-->
                <!--Reset Filters-->
              <!--</button>-->
              <!--<br>-->
            <!--</div>-->
          <!--</div>-->
          <div class="col-md-12 left">
            <fg-select
              v-model="selectedUserType"
              label="Select Account Types"
              :list="userTypes"
              selectedKey="id"
            >
            </fg-select>
            <hr>
            <fg-select v-if="selectedUserType > 1"
              v-model="selectedParentCorpId"
              label="Select Corporation"
              :list="parentCorps"
              selectedKey="corporationId"
            >
            </fg-select>
            <hr>
            <span v-if="subscribers.data.length && subscribers.data.length > 0">
                    <strong>Total Record: {{subscribers.data.length}}</strong><br>
                <!--<a target="_blank" :href="makeOnlineUrl()" @click="downloadCSV()">Download as CSV</a>-->
              </span>
          </div>
        </div>
      </div>
      <div class="table-responsive text-center">
        <l-table class="table table-light table-bordered table-hover"
                 :columns="subscribers.columns" :data="subscribers.data">
          <template slot="table-row" v-if="subscribers.data.length">
            <tr v-for="(item, index) in subscribers.data" :key="index">
              <!--td><img :src="item.smallImage" alt="corporation-image" class="table-thumbnail"></td-->
              <td>{{item.userId}}</td>
              <td>{{item.firstName}}&nbsp;{{item.lastName}}</td>
              <td>{{item.email}}</td>
              <td>{{item.createdOnFmt}}</td>
              <!--<td>-->
                <!--<fg-select-->
                <!--v-model="corporationFilter"-->
                <!--:list="corps"-->
                <!--selectedKey="corporationId"-->
                <!--&gt;-->
                <!--</fg-select>-->
              <!--</td>-->
              <!--<td>-->
              <!--<span class="badge badge-success" v-if="item.active == '1'"> Active </span>-->
              <!--<span class="badge badge-danger" v-else> Inactive </span>-->
              <!--</td>-->
              <td>
              <div class="btn-group" role="group">
              <button class="btn btn-info btn-sm" @click="editUser(item.userId)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
              </div>
              </td>
            </tr>
          </template>
        </l-table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  const columns = ['UserId', 'User Name', 'Email', 'Date Created', 'Action'];
  export default {
    name: 'Subscribers',
    components: {
      LTable,
    },
    data() {
      return {
        selectedUserType: 1,
        userTypes: [{id:1, name:'Free Trials Users'}, {id:2, name:'Corporate Account Users'}],
        selectedParentCorpId: 0,
        parentCorps: [],
        downloadUrl: '',
        tooltips: {
          view: 'View',
          edit: 'Update User Corporation',
          delete: 'Inactivate',
          activate:'Activate',
        },
        subscriptionFilter: 'ALL',
        userFilter: '',
        corporationFilter: '',
        packageFilter: '',
        dateRef: 'Date Created',
        corps: [],
        packages: [],
        userStatus: [{id:"PURCHASE", name:'PURCHASE'}, {id:"TRIAL", name:'TRIAL'},{id:"GIFT", name:'GIFT'} ],
        status: [{id:"ALL", name:'ALL'}, {id:"REGISTERED", name:'REGISTERED'}, {id:"CONFIRMED", name:'CONFIRMED'}, {id:"CANCELLED", name:'CANCELLED'}],
        subscribers: {
          columns: [...columns],
          data: []
        }
      }
    },
    watch: {
      'selectedUserType' (to, from) {
        let self = this
        if (self.selectedUserType > 1) {
          if (self.selectedParentCorpId > 0) {
            self.fetchAllCorpUsers(self.selectedParentCorpId)
          }
        } else {
          self.fetch()
      }
    },
      'selectedParentCorpId' (to, from) {
        let self = this
        console.log('corporation id for users', self.selectedParentCorpId)
        if (self.selectedParentCorpId > 0) {
          self.fetchAllCorpUsers(self.selectedParentCorpId)
        }
      }
    },
    methods: {
      fetchAllCorpUsers (corporationId) {
        this.$store.dispatch('GET_CORP_USERS_DETAILS', corporationId)
          .then((res) => {
            if (res && res.length > 0) {
              console.log('res of users', res)
              this.subscribers.data = res
            } else {
              this.subscribers.data = []
            }
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          this.subscribers.data = []
          console.log("err : ", err);
        }
      },
      fetchParentCorps () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {

            this.parentCorps = res;
            this.parentCorps.unshift({corporationId: 0, name: "Select Corporation"})
            console.log('response', res)
            console.log("this.parentCorps.data : ", this.parentCorps.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      editUser (userId) {
        this.$router.push({ name: 'EditUserAccount', params: { id: userId}});
//        console.log('userId', userId)
//        console.log('corporation', this.corporationFilter)
//        let updateUserCorporation = () =>{
//          this.$store.dispatch('UPDATE_USER_CORPORATION', {
//            corpId: this.corporationFilter, userId: userId
//          })
//            .then((res) => {
//              console.log("UPDATE_CORPORATION res : ", res);
//              this.showPopup('Success!', 'User Corporation is successfully updated', 'success', ()=>this.fetch())
//            })
//            .catch(err => {
//              this.showPopup('Error!', 'some thing happen wrong', 'error')
//              console.log("UPDATE_CORPORATION API error : ", err);
//            })
//        };
//        updateUserCorporation();
      },
      resetFilters () {
        this.subscriptionFilter = 'ALL'
        this.userFilter = ''
        this.corporationFilter = ''
        this.packageFilter = ''
        this.filterData();
      },
      fetchCorporations () {
        this.$store.dispatch('FETCH_PARENTCORPS')
          .then((res) => {
            this.parentCorps = res;
            console.log('response', res)
            console.log("this.parentCorps.data : ", this.parentCorps.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      fetchPackages () {
        this.$store.dispatch('FETCH_CORPORATIONS_PKGS')
          .then((res) => {
            this.packages = res;
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      downloadCSV () {
        this.$store.dispatch('DOWNLOAD_CSV', this.subscriptionFilter)
      },
      makeOnlineUrl () {
        let qryString = ''
        let subFilter = this.subscriptionFilter;
        let userFilter = this.userFilter;
        let pkgFilter = this.packageFilter !== '0' ? this.packageFilter : null;
        let corpFilter = this.corporationFilter !== '0' ? this.corporationFilter : null;
        qryString = `subscriptionType=${subFilter ? subFilter: null}&userType=${userFilter ? userFilter : null}&userPackageId=${pkgFilter ? pkgFilter : 0}&corporationName=${corpFilter ? corpFilter : null}`
        console.log('qury string', qryString);
        let href = window.location.href;
        let origin = ''
        if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
          origin = `https://adminapi1.dev-tonenetworks.com/v1/registration/downloadSubscriberCSVFiltered?${qryString}`
        } else {
          origin = `https://adminapi1.tonenetworks.com/v1/registration/downloadSubscriberCSVFiltered?${qryString}`
        }
        return origin
      },
      filterData () {
        let qryString = ''
        let subFilter = this.subscriptionFilter;
        let userFilter = this.userFilter;
        let pkgFilter = this.packageFilter !== '0' ? this.packageFilter : null;
        let corpFilter = this.corporationFilter !== '0' ? this.corporationFilter : null;
        qryString = `subscriptionType=${subFilter ? subFilter: null}&userType=${userFilter ? userFilter : null}&userPackageId=${pkgFilter ? pkgFilter : 0}&corporationName=${corpFilter ? corpFilter : null}`
        console.log('qury string', qryString);
        this.$store.dispatch('FETCH_SUBSCRIBERS_BY_QUERY', qryString)
          .then((res) => {
            if (res) {
              this.subscribers.data = res;
            } else {
              this.subscribers.data = []
            }
            console.log("this.subscriber.data : ", this.subscribers.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      fetch () {
        let filter = this.subscriptionFilter
        this.$store.dispatch('FETCH_SUBSCRIBERS_FREETRIAL')
          .then((res) => {
            let resultSet = res.payload;
            let filteredList = resultSet.filter( x => {
              return x.userType === 'TRIAL'
            })
            this.subscribers.data = resultSet;
            console.log("this.subscriber.data : ", this.subscribers.data);
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      view(item){
        this.$store.commit('SET_SELECTED_CORPORATION', item);
        this.$router.push({ name: 'Corporation Details', params: { id:  item.corporationId}})
      },
      edit(item){
        this.$store.commit('SET_SELECTED_CORPORATION', item);
        this.$router.push({ name: 'Edit Corporation', params: { id: item.corporationId}});
      },
      create(){
        this.$router.push({ name: 'Create Corporation'})
      },
      statusChange(item, boolean){
        this.$store.dispatch('DELETE_CORPORATION', {corporationId: item.corporationId, isDelete: boolean})
          .then((res) => {
            console.log("DELETE_CORPORATION API res : ", res);
            this.fetch();
          })
          .catch(err => {
            console.log("DELETE_CORPORATION API error : ", err);
          })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
    },
    created() {
      this.fetchParentCorps();
      this.fetchPackages();
      this.fetch();
    },
    computed:{
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    }
  }
</script>

<style>
  .btn-icon{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UserAccounts.vue